import { MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogData } from "../shared/dialogs/confirm-dialog/confirm-dialog.component";

export const DELETE_RECOVERY_PLAN_DIALOG_CONFIG: MatDialogConfig<ConfirmDialogData> =
  {
    data: {
      title: "Delete recovery plan",
      message: "Do you want to delete this Recovery Plan?",
      inputForm: [],
    },
  };
